import { render } from "./GalleryBoxDefaultState.vue?vue&type=template&id=bc4bee6c"
import script from "./GalleryBoxDefaultState.vue?vue&type=script&lang=js"
export * from "./GalleryBoxDefaultState.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "bc4bee6c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bc4bee6c', script)) {
    api.reload('bc4bee6c', script)
  }
  
  module.hot.accept("./GalleryBoxDefaultState.vue?vue&type=template&id=bc4bee6c", () => {
    api.rerender('bc4bee6c', render)
  })

}

script.__file = "resources/js/Pages/Station/Gallery/GalleryBoxDefaultState.vue"

export default script